import gql from 'graphql-tag';
import client from '../graphqlAPI';

const GET_LOYALTY_ACTIVITY = gql`
  query getLoyaltyActivity($from: Int, $to: Int) {
    getLoyaltyActivity(from: $from, to: $to) {
      isAuth
      hasMore
      items { email slugName type points createdAt claimedAt }
    }
  }
`;

const getLoyaltyActivity = async (variables) => {
  try {
    const result = await client.query({
      query: GET_LOYALTY_ACTIVITY, variables, errorPolicy: 'all', fetchResults: true, fetchPolicy: 'no-cache',
    }).catch((queryError) => {
      console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ getLoyaltyActivity Query Error: ${queryError}`);
      return null;
    });
    return result && result.data ? result.data.getLoyaltyActivity : null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ getLoyaltyActivity Error: ${error}`);
    return null;
  }
};

export default getLoyaltyActivity;
